function Imprint() {
	const imprintElement = document.querySelector('.imprint');

	function open() {
		BODY_ELEMENT.classList.add('body-imprint');
	}

	function close() {
		BODY_ELEMENT.classList.remove('body-imprint');
	}

	this.open = open;
	this.close = close;
}

export default Imprint;
